import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';


import MovieListHeading from './components/MovieListHeading';

import Pagination from './components/pagination/Pagination';
import Header from './components/header/Header';
import { AuthContext } from './context/authContext';
import MovieList from './components/moveList/MovieList';
import logger from './lib/logger';
import SearchBox from './components/searchBox/SearchBox';

const Home = () => {
  const [movies, setMovies] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [triggerSearch, setTriggerSearch] = useState(true);
  const [isAiSearch, setIsAiSearch] = useState(false);
  const [loading, setLoading] = useState(false);
  const [authPanelVisible, setAuthPanelVisible] = useState(false);


  useEffect(() => {
    const getMovieRequest = async (page = 1) => {
      setLoading(true);
      if (isAiSearch) {
        try {
          const aiUrl = "http://localhost:4000/v0/api/search/ai-search";
          const response = await fetch(aiUrl, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              chat_history: searchValue.trim(),
              per_page: 18,
              page: page,
            }),
          });
          const responseJson = await response.json();
          // logger.log(responseJson.structuredResponse.data);

          // Assemble videos array based on IDs returned from AI search.
          const videos = [];
          const ids = responseJson.structuredResponse.data.map(item => item.id);
          for (let i = 0; i < ids.length; i++) {
            const videoUrl = `https://www.eporner.com/api/v2/video/id/?id=${ids[i]}`;
            const videoResponse = await fetch(videoUrl);
            const videoData = await videoResponse.json();
            if (videoData) {
              videos.push(videoData);
            }
          }
          const totalPagesCalculated = Math.ceil(videos.length / 18);
          setMovies(videos);
          setTotalPages(totalPagesCalculated);
        } catch (error) {
          logger.error("Failed to fetch AI movies:", error);
        } finally {
          setLoading(false);
        }
      } else {
        // Traditional search API endpoint.
        const baseUrl = `https://www.eporner.com/api/v2/video/search/`;
        const url = searchValue
          ? `${baseUrl}?query=${encodeURIComponent(searchValue.trim())}&per_page=18&page=${page}`
          : `${baseUrl}?per_page=18&page=${page}`;
        try {
          const response = await fetch(url);
          const responseJson = await response.json();
          if (responseJson.videos) {
            setMovies(responseJson.videos);
            setTotalPages(responseJson.total_pages || 1);
          } else {
            setMovies([]);
            setTotalPages(0);
          }
        } catch (error) {
          logger.error("Failed to fetch movies:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    if (triggerSearch) {
      getMovieRequest(currentPage);
      setTriggerSearch(false);
    }
  }, [searchValue, currentPage, triggerSearch, isAiSearch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setTriggerSearch(true);
  };

  const handleSearch = () => {
    setIsAiSearch(false);
    setCurrentPage(1);
    setTriggerSearch(true);
  };

  const handleAiSearch = () => {
    setIsAiSearch(true);
    setCurrentPage(1);
    setTriggerSearch(true);
  };

  // Toggles the mobile auth panel visibility.
  const toggleAuthPanel = () => {
    setAuthPanelVisible(prev => !prev);
  };

  return (
    <div className="app-container">
      {/* Fixed Header */}
      <Header />

      {/* Add a spacer if needed since Header is fixed */}
      <div className="header-spacer"></div>

      {/* Main Content Section */}
      <div className="content-section">
        {/* Search Section */}
        <div className="header-section">
          <div className="header-left">
            {/* <MovieListHeading heading="W2Porn" /> */}
          </div>
  
            <SearchBox
              searchValue={searchValue}
              setSearchValue={setSearchValue}
              onSearch={handleSearch}
              onAiSearch={handleAiSearch}
              isAiSearch={isAiSearch}
              loading={loading}
            />

   
        </div>

        {/* Loader or Movie List */}
        {loading ? (
          <div className="loader-wrapper">
            <div className="loader"></div>
            {isAiSearch && (
              <p className="loader-text">AI search might take a bit longer...</p>
            )}
          </div>
        ) : (
          <div className="movie-list-wrapper">
            <MovieList movies={movies} />
          </div>
        )}

        {/* Pagination */}
        {totalPages > 1 && !loading && (
          <div className="pagination-wrapper">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              showRange={2}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default Home;
